<template>
<!--  internal staff only-->
  <div v-if="$root.user_role == '2'">
    <div class="columns">
      <div class="column">
        <!--search-->
        <div class="columns">
          <div class="column is-6">
            <b-button v-if="showCreateEnvelop == false" expanded outlined type="is-info" rounded @click="createNewEnvelope()" icon-left="email-open">Create New Envelop</b-button>

            <b-field v-if="showCreateEnvelop"
                :type="invalidDocumentName == '' ? '' : 'is-danger'"
                :message="invalidDocumentName"
                label="Document Name"
                style="text-align: left"
                :label-position="labelPosition"
            >
              <b-input
                  type="text"
                  v-model="documentName"
                  @input="resetInvalidStatus('invalidDocumentName')"
                  rounded
              ></b-input>
            </b-field>
          </div>

          <div class="column">

          </div>
        </div>

        <div class="columns" >
          <div class="column">
            <!--create new document & uploaded document show-->
              <div class="upload-area" v-if="showCreateEnvelop == true && showUploadedDocument == false">
                <div id="docButton">
                  <b-field class="file is-primary" style="margin-left: 20px">
                    <b-upload v-model="file" class="file-label" @input="filechange()">
                  <span class="file-cta">
                      <b-icon class="file-icon" icon="upload"></b-icon>
                      <span class="file-label">Click to upload</span>
                  </span>
                    </b-upload>
                  </b-field>
                  <p style="color: #9a9a9a;">Maximum upload size is 50 MB</p>
                  <p style="color: #9a9a9a;">File Type : PDF Only</p>
                </div>
                <img src="../../../assets/gifs/docUpload.gif" alt="uploadDoc-gif">
              </div>

            <!--upload document-->
            <div v-if="showUploadedDocument" id="drop-zone" class="drop-zone" @click="mouseClickMove($event,elementId)" >
              <!--textboxes---------------------------------------------------------------------------------------->
              <div v-for="box in textBoxes" :key="box.id" :id="box.id" class="draggable">
                <button v-if="!isSaved" class="delete" type="button" @click="openPlaceholderRemove(box.id,'text-box')"></button>
                <p>text-box {{box.id}}</p>
              </div>

              <!--signatures---------------------------------------------------------------------------------------->
              <div v-for="sign in signatures" :key="sign.id" :id="sign.id" class="draggable">
                <button v-if="!isSaved"  class="delete" type="button" @click="openPlaceholderRemove(sign.id,'signature')"></button>
                <p type="is-primary">Signature {{sign.id}}</p>
              </div>

              <!--checkBox---------------------------------------------------------------------------------------->
              <div v-for="checkbox in checkboxes" :key="checkbox.id" :id="checkbox.id" class="draggable">
                <button v-if="!isSaved" class="delete" type="button" @click="openPlaceholderRemove(checkbox.id,'check-box')"></button>
                <p  type="is-success">checkbox {{checkbox.id}}</p>
              </div>

              <!--date pickers---------------------------------------------------------------------------------------->
              <div v-for="datepicker in datepickers" :key="datepicker.id" :id="datepicker.id" class="draggable">
                <button v-if="!isSaved" class="delete" type="button" @click="openPlaceholderRemove(datepicker.id,'date-picker')"></button>
                <p  type="is-warning">Date-picker {{datepicker.id}}</p>
              </div>

              <canvas :id="'the-canvas'+render" style="width: 100%; height: 100%;border: 1px solid black" v-for="render in TotPage" :key="render.id"></canvas>
            </div>
          </div>

          <div class="column is-4">
                <div class="columns" v-if="showTemplateList">
                  <div class="column">
                    <b-field>
                      <b-input
                          v-model="search"
                          type="search"
                          icon="magnify"
                          placeholder="Search"
                          value=""
                          rounded>
                      </b-input>
                    </b-field>
                  </div>
                  <div class="column is-3">
                    <b-button :loading="isSubmitting" :disabled="showUploadedDocument == false" class="is-info" @click="searchRecipient()">Search</b-button>
                  </div>
                </div>

            <!--search result-->
            <div class="columns">
              <Transition  name="slide-fade">
                 <span v-if="recordsNotFound" style="box-shadow: -4px 4px 4px rgba(13, 93, 163, 0.09); padding:10px;;width:100%;display: block">
                    <p class=" has-text-grey-lighter">No records to display</p>
                    <a class="is-info" @click="showAddInviteeModal = true">Add Recipient</a>
                </span>
                <span v-if="searchResult" style="box-shadow: -4px 4px 4px rgba(13, 93, 163, 0.09); padding:10px;;width:100%;display: block">
                    <div class="columns" v-for="results in DataList" :key="results.id">
                      <div class="column">
                        <p>{{results.invitee_name}}</p>
                      </div>
                      <div class="column is-4">
                        <b-button size="is-small" type="is-success" icon-right="plus" @click="addExistInvitee(results.id)" />
                      </div>
                    </div>
                </span>
              </Transition>
            </div>

            <br>
            <!--template list---------------------------------------------------------->
            <div class="box"  v-if="showTemplateList">
              <div class="placeholder-card"  style="padding: 10px;height: 300px;overflow-y: scroll">
                <p style="text-align: left; font-weight: bold; font-size: 20px" class="mt-2">Template List</p>
                <div class="column" v-for="data in templateList" :key="data.id">
                  <div class="placeholder-card" style="border: 1px solid black;border-radius: 10px; padding:10px">
                    <div class="columns">
                      <div class="column is-8">
                        <span>{{data.template_name}}</span>
                      </div>
                      <div class="column is-3">
                         <b-button :disabled="showUploadedDocument" class="is-success" icon-left="plus" @click="addTemplateToDocumentUploadArea(data.document_path)">Add</b-button>
                      </div>
                    </div>

                  </div>
                </div>
              </div>

              <div style="margin-top: 30px;border-top: 1px solid #A5A6B3;"></div>
              <!-- placeholders---------------------------------------------------------------------->
              <div class="placeholder-card" v-if="showUploadedDocument" style="padding: 10px">
                <p style="text-align: left; font-weight: bold; font-size: 20px" class="mt-2">Place Holders</p>
                <b-button expanded class="mt-3" :disabled="isSaved" @click="openInviteeAssingModal('text-box')">Textfield</b-button>
                <b-button expanded class="mt-3" :disabled="isSaved" @click="openInviteeAssingModal('signature')">Signature</b-button>
                <b-button expanded class="mt-3" :disabled="isSaved" @click="openInviteeAssingModal('checkbox')">Checkbox</b-button>
                <b-button expanded class="mt-3" :disabled="isSaved" @click="openInviteeAssingModal('date-picker')">Date</b-button>

                <div style="margin-top: 30px;border-top: 1px solid #A5A6B3;">
                  <div class="columns mt-2">
                    <div class="column">
                      <p style="text-align: left; font-weight: bold; font-size: 20px;">Recipients</p>
                    </div>
<!--                    <div class="column">-->
<!--                      <b-button @click="showAddInviteeScreen" :disabled="isSaved">Add</b-button>-->
<!--                    </div>-->
                  </div>
                </div>

                <!--invitee list -------------------------------------------------------------------------->
                <div style="height: 300px;overflow-y: scroll">
                  <div class="invitee-card" v-for="invitee in inviteeList" :key="invitee.id" :id="'inv'+invitee.id">
                    <div class="card-content">
                      <p style="text-align: left"> {{invitee.fullName}}</p>
                      <p style="text-align: left;">Position : {{invitee.sign_order}}</p>
                    </div>
                    <footer class="card-footer" style="padding: 10px">
                      <b-button size="is-small" class="is-danger" @click="removeInvitee(invitee.id)" :disabled="isSaved">Remove</b-button>
                    </footer>
                  </div>
                </div>

              <!--attachments-------------------------------------------------------------->
                <div style="margin-top: 30px;border-top: 1px solid #A5A6B3;">
                  <div class="placeholder-card" v-if="showUploadedDocument" style="padding: 10px">
                    <p style="text-align: left; font-weight: bold; font-size: 20px" class="mt-2">Attachments</p>

                    <b-field class="file" >
                      <b-upload @input="handleAttachmentFile"  expanded multiple>
                        <a class="button is-dark is-fullwidth">
                          <b-icon icon="attachment"></b-icon>
                          <span>Click to upload</span>
                        </a>
                      </b-upload>
                    </b-field>

                   <div class="columns" v-for="attachment in attachments" :key="attachment.id">
                     <div class="column">
                       <div class="box">
                         <p>{{attachment.name}}</p>
                         <footer class="card-footer" style="padding: 10px">
                           <b-button size="is-small" class="is-danger" @click="removeAttachments(attachment.id)" :disabled="isSaved">Remove</b-button>
                         </footer>
                       </div>
                     </div>
                   </div>

                  </div>
                </div>

                <hr style="border-top: 1px solid #A5A6B3;">
                <div class="mt-3">
                  <div class="columns">
                    <div class="column">
                      <b-button outlined rounded expanded type="is-primary"  @click="savePDFwithCoordinates" :disabled="enabledSaveButton" :loading="isSaveSubmitting">Save </b-button>
                    </div>
                    <div class="column">
                      <b-button outlined rounded expanded type="is-primary"  :loading="isSubmitting" :disabled="!enabledSaveButton" @click="openSendDocModal">Send </b-button>
                    </div>
                    <div class="column">
                      <b-button rounded expanded @click="showdocumentRemoveModal = true" >Cancel</b-button>
                    </div>

                  </div>
                </div>

              </div>
            </div>
          </div>

        </div>
      </div>

    </div>

    <!--file upload modal-->
    <FileUpload v-if="fileUploadModal" @file-uploaded="fileUploading" @closeFileUploadModal="fileUploadModal = false" />

    <!--file loading modal-->
    <FileLoading v-if="showLoadingModal" />

    <!--file upload success modal-->
    <b-modal v-model="showSuccessModal" :width="300"  animation="zoom-out" >
      <div class="loading-modal">

        <div class="card-content" style="padding-top: 30px">
          <img :src="require('@/assets/gifs/file-upload-success.gif')" alt="document-upload-success">
        </div>

      </div>
    </b-modal>

    <!--add invitees modal-->
    <b-modal v-model="showAddInviteeModal" :width="400" animation="zoom-out" @close="clearInviteeData">
      <div class="model-card">

        <header class="modal-card-head">
          <p class="modal-card-title">Add Recipient</p>
          <button @click="clearInviteeData" type="button" class="delete"></button>
        </header>

        <div class="modal-card-body">
          <div class="content pt-2">
             <p style="color: #393953">Fill or Review the details to invite people to get their signature </p>

            <div class="mt-5">
              <b-field
                  :type="invalidFullName == '' ? '' : 'is-danger'"
                  :message="invalidFullName"
                  label="Name"
                  style="text-align: left"
                  :label-position="labelPosition"
              >
                <b-input
                    type="text"
                    v-model="inviteeFormData.fullName"
                    placeholder="Jason carter"
                    @input="resetInvalidStatus('invalidFullName')"
                    rounded
                ></b-input>
              </b-field>
            </div>

            <div class="mt-5">
              <b-field
                  :type="invalidEmail == '' ? '' : 'is-danger'"
                  :message="invalidEmail"
                  label="Email"
                  style="text-align: left"
                  :label-position="labelPosition"
              >
                <b-input
                    type="email"
                    v-model="inviteeFormData.email"
                    placeholder="Jasoncarter@gmail.com"
                    @input="resetInvalidStatus('invalidEmail')"
                    rounded
                ></b-input>
              </b-field>
            </div>

            <div class="mt-5">
              <b-field
                  :type="invalidContactNumber == '' ? '' : 'is-danger'"
                  :message="invalidContactNumber"
                  label="Contact Number"
                  style="text-align: left"
                  :label-position="labelPosition"
              >
                <b-input
                    type="text"
                    v-model="inviteeFormData.contactNumber"
                    placeholder="071XXXXXXX"
                    @input="resetInvalidStatus('invalidContactNumber')"
                    rounded
                ></b-input>
              </b-field>
            </div>

            <div class="mt-5">
              <b-field
                  style="text-align: left"
                  label="Position"
                  :type="invalidPosition == '' ? '' : 'is-danger'"
                  :message="invalidPosition"
                  :label-position="labelPosition">

                <b-select placeholder="Select a position" rounded expanded v-model="inviteeFormData.position" @input="resetInvalidStatus('invalidPosition')">
                  <option value="1">Position 1</option>
                  <option v-for="position in positions" :key="position.id" :value="position.value">{{position.name}}</option>
                </b-select>
              </b-field>
            </div>

            <div class="mt-5">
              <b-field
                  style="text-align: left"
                  label="Language"
                  :type="invalidLanguage == '' ? '' : 'is-danger'"
                  :message="invalidLanguage"
                  :label-position="labelPosition">

                <b-select placeholder="Select a language" rounded expanded v-model="inviteeFormData.language" @input="resetInvalidStatus('invalidLanguage')">
                  <option v-for="language in languageList" :key="language" :value="language">{{language}}</option>
                </b-select>
              </b-field>
            </div>

            <div class="mt-5" style="text-align: left; font-size: 14px">
              <b-field>
                <b-checkbox v-model="inviteeFormData.saveRecipient">Save Recipient</b-checkbox>
              </b-field>
            </div>

            <div style="margin-top: 40px">
              <div class="columns">
                <div class="column">
                  <b-button type="is-info" rounded expanded outlined @click="clearInviteeData">Back</b-button>
                </div>
                <div class="column">
                  <b-button type="is-primary" rounded expanded outlined @click="addInvitees">Add</b-button>
                </div>
              </div>

            </div>

          </div>
        </div>

      </div>
    </b-modal>

    <!--send doc modal-->
    <b-modal v-model="showSendDocModal" :width="400"  animation="zoom-out">
      <div class="model-card">

        <header class="modal-card-head">
          <p class="modal-card-title">Send Document</p>
          <button @click="showSendDocModal= false" type="button" class="delete"></button>
        </header>

        <div class="modal-card-body">
          <div class="content pt-2">
            <p style="color: #393953; text-align: left">From : <span>{{ username }}</span></p>
            <p style="color: #393953;text-align: left" v-for="invitee in inviteeList" :key="invitee.id">To : <span>{{invitee.email}}</span></p>
            <p style="color: #393953; text-align: left"><span><b-checkbox v-model="reviewOnly">Review Only</b-checkbox></span></p>
            <p style="color: #393953; text-align: left"><span><b-checkbox v-model="showMessagetextBox">Add Message</b-checkbox></span></p>

            <div style="margin-top: 40px">
              <b-field
                       v-if="showMessagetextBox"
                       label="Message"
                       :type="invalidMessage == '' ? '' : 'is-danger'"
                       :message="invalidMessage"
                       style="text-align: left"
                       :label-position="labelPosition">
                <b-input maxlength="100" type="textarea" v-model="message"  @input="resetInvalidStatus('invalidMessage')"></b-input>
              </b-field>
            </div>

            <div style="margin-top: 40px">
              <b-button type="is-primary" rounded expanded outlined @click="ValidateAndsendDocumentLink" :loading="isSubmitting">Send</b-button>
            </div>

          </div>
        </div>

      </div>
    </b-modal>

    <!--document success modal-->
    <SendSuccessModal v-if="showSendSuccessModal" v-on:closeDocumentSendModal="resetWindow()" />

    <b-modal v-model="showdocumentRemoveModal" :width="400"  animation="zoom-out">
      <div class="model-card">

        <header class="modal-card-head">
          <p class="modal-card-title">Remove Document</p>
        </header>

        <div class="modal-card-body">
            <p>Do you want to remove this document?</p>
            <div class="img-doc">
              <img :src="require('@/assets/icon/pdf.png')" alt="document-png" align="center">
            </div>

            <div style="margin-top: 40px">
              <b-button type="is-primary" outlined rounded expanded @click="removeDoc">Remove Document</b-button>
            </div>
        </div>
      </div>
    </b-modal>

    <!--assing invitees to placeholders-->
    <b-modal v-model="showInviteeAssignModal" :width="400"  animation="zoom-out" @close="resetAssignInviteeModal">
      <div class="model-card">

        <header class="modal-card-head">
          <p class="modal-card-title">Assign Invitee</p>
          <button @click="showInviteeAssignModal = false" type="button" class="delete"></button>
        </header>

        <div class="modal-card-body">
          <div class="content pt-2">
            <b-field label="Select Invitee">
              <b-select placeholder="Select a name" v-model="selectedInvitee">
                <option
                    v-for="invitee in inviteeList" :key="invitee.id"
                    :value="invitee.id">
                  {{ invitee.fullName}}
                </option>
              </b-select>
            </b-field>
            <div >

            </div>

            <div style="margin-top: 40px">
              <b-button type="is-primary" rounded expanded outlined @click="AddElementWithInviteeID">Add</b-button>
            </div>

          </div>
        </div>

      </div>
    </b-modal>

    <!--placeholder remove component-->
    <b-modal v-model="showPlaceholderRemoveModal" :width="400"  animation="zoom-out">
      <div class="model-card">

        <header class="modal-card-head">
          <p class="modal-card-title">Warning !</p>
          <button type="button" class="delete" @click="showPlaceholderRemoveModal = false"></button>
        </header>

        <div class="modal-card-body">
          <div class="content pt-2">

            <div >
              Do you want to remove this placeholder?
            </div>

            <div style="margin-top: 40px">
              <div class="columns">
                <div class="column">
                  <b-button type="is-danger" rounded expanded outlined @click="removePlaceholders(placeholderID,placeholderType)">Yes</b-button>
                </div>
                <div class="column">
                  <b-button type="is-info" rounded expanded outlined @click="showPlaceholderRemoveModal = false">No</b-button>
                </div>
              </div>

            </div>

          </div>
        </div>

      </div>
    </b-modal>

    <!--add exist invitees  -->
    <b-modal v-model="showExistInviteeModal" :width="400" animation="zoom-out" @close="clearInviteeData">
      <div class="model-card">

        <header class="modal-card-head">
          <p class="modal-card-title">Add Recipient</p>
          <button @click="clearInviteeData" type="button" class="delete"></button>
        </header>

        <div class="modal-card-body">
          <div class="content pt-2">
            <p style="color: #393953">Fill or Review the details to invite people to get their signature </p>

            <div class="mt-5">
              <b-field
                  :type="invalidFullName == '' ? '' : 'is-danger'"
                  :message="invalidFullName"
                  label="Name"
                  style="text-align: left"
                  :label-position="labelPosition"
              >
                <b-input
                    type="text"
                    v-model="inviteeFormData.fullName"
                    placeholder="Jason carter"
                    @input="resetInvalidStatus('invalidFullName')"
                    disabled
                    rounded
                ></b-input>
              </b-field>
            </div>

            <div class="mt-5">
              <b-field
                  :type="invalidEmail == '' ? '' : 'is-danger'"
                  :message="invalidEmail"
                  label="Email"
                  style="text-align: left"
                  :label-position="labelPosition"
              >
                <b-input
                    type="email"
                    v-model="inviteeFormData.email"
                    placeholder="Jasoncarter@gmail.com"
                    @input="resetInvalidStatus('invalidEmail')"
                    rounded
                    disabled
                ></b-input>
              </b-field>
            </div>

            <div class="mt-5">
              <b-field
                  :type="invalidContactNumber == '' ? '' : 'is-danger'"
                  :message="invalidContactNumber"
                  label="Contact Number"
                  style="text-align: left"
                  :label-position="labelPosition"
              >
                <b-input
                    type="text"
                    v-model="inviteeFormData.contactNumber"
                    placeholder="071XXXXXXX"
                    @input="resetInvalidStatus('invalidContactNumber')"
                    rounded
                    disabled
                ></b-input>
              </b-field>
            </div>

            <div class="mt-5">
              <b-field
                  style="text-align: left"
                  label="Position"
                  :type="invalidPosition == '' ? '' : 'is-danger'"
                  :message="invalidPosition"
                  :label-position="labelPosition">

                <b-select placeholder="Select a position" rounded expanded v-model="inviteeFormData.position" @input="resetInvalidStatus('invalidPosition')">
                  <option value="1">Position 1</option>
                  <option v-for="position in positions" :key="position.id" :value="position.value">{{position.name}}</option>
                </b-select>
              </b-field>
            </div>

            <div class="mt-5">
              <b-field
                  style="text-align: left"
                  label="Language"
                  :type="invalidLanguage == '' ? '' : 'is-danger'"
                  :message="invalidLanguage"
                  :label-position="labelPosition">

                <b-select placeholder="Select a language" rounded expanded v-model="inviteeFormData.language" @input="resetInvalidStatus('invalidLanguage')">
                  <option v-for="language in languageList" :key="language" :value="language">{{language}}</option>
                </b-select>
              </b-field>
            </div>

            <div class="mt-5" style="text-align: left; font-size: 14px">
              <b-field>
                <b-checkbox v-model="inviteeFormData.saveRecipient">Save Recipient</b-checkbox>
              </b-field>
            </div>

            <div style="margin-top: 40px">
              <div class="columns">
                <div class="column">
                  <b-button type="is-info" rounded expanded outlined @click="clearInviteeData">Back</b-button>
                </div>
                <div class="column">
                  <b-button type="is-primary" rounded expanded outlined @click="addInvitees">Add</b-button>
                </div>
              </div>

            </div>

          </div>
        </div>

      </div>
    </b-modal>

  </div>
</template>

<script>
import axios from "axios";
// import interact from "interactjs";
import * as pdfjsLib from 'pdfjs-dist'
import pdfjsWorker from 'pdfjs-dist/build/pdf.worker.entry'

import SendSuccessModal from "@/components/common/SendSuccessModal";
import FileLoading from "@/components/backend/FileLoading";
import FileUpload from "@/components/backend/FileUpload";


export default {
  name:'dashboard-view',

  components :{
    SendSuccessModal,
    FileLoading,
    FileUpload,

  },

  data(){
    return this.initalState();

  },

  mounted() {
    this.validateToken()
    this.getTemplateList()
    this.getRecentDocs()
  },

  computed:{
    filteredDataArray() {
      return this.List.filter((option) => {
        return option
            .toString()
            .toLowerCase()
            .indexOf(this.search.toLowerCase()) >= 0
      })
    }
  },

  methods:{

    initalState(){
      return{

        search:'',
        DataList:[],
        saveRecipient:'',
        searchResult:'',
        recordsNotFound:'',

        showExistInviteeModal:false,
        attachments:[],
        documentID:'',
        colorCode:'',

        showCreateEnvelop:false,

        labelPosition: "on-border",
        passwordConfirm:"",
        fileUploadModal:false,
        showTemplateList:false,

        file:'',
        filename:'',
        templateList:[],
        documentName:'',

        //invitees positions
        positions:[],
        inviteeCount:1,

        //coordinates for each element
        signCoordinate:[],
        checkbxCoordinate:[],
        inputCoordinate:[],
        datepickerCoordinate:[],

        countDown:10,
        showLoadingModal:false,
        showSuccessModal:false,
        showinviteesModal:false,
        showAddInviteeModal:false,
        selectPosition:'',

        showUploadedDocument:false,
        showSendDocModal:false,
        showSendSuccessModal:false,
        showdocumentRemoveModal:false,
        showInviteeAssignModal:false,
        showCheckInviteeNICModal:false,
        showPlaceholderRemoveModal:false,

        formIsSubmitting:false,

        TodayUploadDoc:[],

        TotPage:0,
        Pageindex:[],
        currentFileUrl:'',
        elementId:0,

        textBoxes:[],
        signatures:[],
        checkboxes:[],
        datepickers:[],
        coordinates:[],


        isSaved:false,
        finalCoordinates:[],
        isSubmitting:false,

        inviteeFormData:{
          fullName:'',
          email:'',
          contactNumber:'',
          position:null,
          language:null,
          saveRecipient:'',
          client_number:''
        },

        languageList:[
            'Sinhala',
            'Tamil',
            'English'
        ],

        invalidEmail:'',
        invalidFullName: '',
        invalidContactNumber: '',
        invalidNIC:'',
        invalidPosition:'',
        invalidStartNIC:'', // first screen nic
        invalidLanguage:'',
        invalidMessage:'', //document send modal
        invalidDocumentName:'',

        inviteeList:[],
        inviteeID:0,
        formIsInvalid:false,
        selectedInvitee:null,
        elementType:'',
        inviteeExists:'',
        inviteeNIC:'',
        ExistsInviteeNIC:'',
        enabledSaveButton:false,

        username:'',
        message:'',
        showMessagetextBox:false,

        regex:{
          fullName: /^[a-zA-Z][a-zA-Z ]+$/,
          message: /[a-zA-Z0-9]+\s?[a-zA-Z0-9]+$/,
          contactNumber:/^(?:0|94|\+94)7(0|1|2|4|5|6|7|8)\d\d{6}$/,
          nic:/^([0-9]{9}[x|X|v|V]|[0-9]{12})$/,
          email: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        },

        documentInviteeIDArray:[],

        isSaveSubmitting:false,

        //recetdocs
        RecentDocs:[],

        reviewOnly:false,
        filesCount:'',
        SearchMessage:''
      }

    },

    filechange:function (){
      var component = this

      const filesize = Math.round(( event.target.files[0].size / 1024));
      if(event.target.files[0].type == 'application/pdf'){
        if (filesize >= 50000) {
          component.$buefy.toast.open({
            message: 'Please select a file less than 50mb',
            type: 'is-danger',
            duration:2000
          })

        } else {
          // component.filename = "Selected File: " + event.target.files[0].name;
          component.currentFileUrl = URL.createObjectURL(event.target.files[0])
          component.file = event.target.files[0]
          component.$root.file_url = event.target.files[0];

          component.showDocumentUpload = true
          component.showLoadingModal = true
          //envelop & templatelist
          component.showCreateEnvelop = true
          component.showTemplateList = true
          this.countDownTimer()
        }
      }else{
        component.$buefy.toast.open({
          message: 'Invalid Document Type',
          type: 'is-danger',
          duration:2000
        })
      }
    },

    createNewEnvelope:function (){
      var comp = this

      comp.showCreateEnvelop = true;
      comp.showTemplateList =true

      // let formData = new FormData()
      // formData.append('auth_token',comp.$root.agentAuthToken)
      // formData.append('user_id',comp.$root.user_id)
      // axios.post(comp.$base_url+'/agent/createEnvelope',formData)
      //     .then(function (response) {
      //       console.log(response.data)
      //       comp.$root.enevelop_id = response.data.data
      //       comp.showCreateEnvelop = true;
      //       comp.showTemplateList =true
      //     })
      //     .catch(function (error) {
      //       console.log(error)
      //       comp.$buefy.toast.open({
      //         message: error.message,
      //         type: "is-danger",
      //       });
      //     });

    },

    removeAttachments:function (attachmentID){
      var component = this
      component.attachments.forEach((attachment,index)=>{
        if (attachment.id == attachmentID) {
          component.attachments.splice(index, 1);
          component.$buefy.toast.open({
            message: 'Attachment is removed',
            type: 'is-success'
          })
        }

      });
    },

    assingColortoPlaceholders:function (){

      this.inviteeList.forEach((invitee)=>{

        this.textBoxes.forEach((textbox)=>{
              if(invitee.id == textbox.inviteeid){
                console.log('same')
                var element = document.getElementById(textbox.id)
                element.style.backgroundColor = invitee.color
                element.style.color= '#ffff'
                element.style.padding = '10px'
              }
        })

        this.signatures.forEach((signature)=>{
          if(invitee.id == signature.inviteeid){
            console.log('same')
            var element = document.getElementById(signature.id)
            element.style.backgroundColor = invitee.color
            element.style.color= '#ffff'
            element.style.padding = '10px'
          }
        })

        this.datepickers.forEach((date)=>{
          if(invitee.id == date.inviteeid){
            console.log('same')
            var element = document.getElementById(date.id)
            element.style.backgroundColor = invitee.color
            element.style.color= '#ffff'
            element.style.padding = '10px'
          }
        })

        this.checkboxes.forEach((checkbox)=>{
          if(invitee.id == checkbox.inviteeid){
            console.log('same')
            var element = document.getElementById(checkbox.id)
            element.style.backgroundColor = invitee.color
            element.style.color= '#ffff'
            element.style.padding = '10px'
          }
        })
      })
    },

    handleAttachmentFile:function (){
      var component = this

      const filesize = Math.round(( event.target.files[0].size / 1024));
      // The size of the file.
      if (filesize >= 50000) {
        component.$buefy.toast.open({
          message: 'Please select a file less than 50mb',
          type: 'is-danger',
          duration:2000
        })

      } else {

        console.log('files on change-------------------------------------')
        var filelist = []
        filelist = event.target.files

        for (var i = 0; i < filelist.length; i++ ){
          let file = filelist[i];
          component.attachments.push({id:i, name:file.name, file:file})
          console.log(file);
        }
      }
    },

    addExistInvitee:function (elementID){
      this.showExistInviteeModal = true
      var item = this.DataList.find(item => item.id === elementID);

      this.inviteeFormData.fullName = item.invitee_name;
      this.inviteeFormData.email = item.invitee_email;
      this.inviteeFormData.contactNumber = item.invitee_contact_number;
      this.inviteeFormData.client_number = item.client_number
    },

    searchRecipient:function (){
      var component = this

      if(component.search == ''){
        component.$buefy.toast.open({
          message: 'Please enter email or contact number',
          type: 'is-danger'
        })
      }else{
        component.isSubmitting = true
        axios.post(component.$base_url+'/agent/searchRecipient',{
          searchKeyTerm:component.search,
          auth_token:component.$root.agentAuthToken,
        })
            .then(function (response){
              component.isSubmitting = false
              if(response.data.success == true){
                console.log(response.data.data)
                if(response.data.data.length > 0){
                  component.DataList = response.data.data
                  component.searchResult = true
                  component.recordsNotFound = false
                }else{
                  component.recordsNotFound = true
                  component.searchResult = false
                }
              }else{
                //show alert
                component.$buefy.toast.open({
                  message: 'Failed get coordinates',
                  type: 'is-danger'
                })
              }

            }).catch(function (error) {
          console.log(error);
        });
      }

    },

    addTemplateToDocumentUploadArea:function (document_url){
      this.renderTemplate(document_url)
    },


    renderTemplate:function (document_url){
      var component = this
      var  url = component.$base_public_url+document_url

      pdfjsLib.GlobalWorkerOptions.workerSrc = pdfjsWorker
      var loadingTask = pdfjsLib.getDocument(url)

      loadingTask.promise.then(function(pdf) {
        console.log('PDF loaded');

        // Fetch the first page

        var totalpages = pdf.numPages;
        component.TotPage = totalpages
        console.log("Total pages : "+totalpages)

        for(var x = 1; x <= totalpages; x++){
          console.log("current page index : "+x)
          component.Pageindex.push({pageIndex:x})
        }

        if(totalpages > 1) {
          component.Pageindex.forEach((element)=>{
            pdf.getPage(element.pageIndex).then(function(page) {
              console.log('Page loaded');

              var scale = 1.5;
              var viewport = page.getViewport({scale: scale});

              // Prepare canvas using PDF page dimensions
              var canvas = document.getElementById('the-canvas'+element.pageIndex);

              var context = canvas.getContext('2d');
              canvas.height = viewport.height;
              canvas.width = viewport.width;

              // Render PDF page into canvas context
              var renderContext = {
                canvasContext: context,
                viewport: viewport
              };
              var renderTask = page.render(renderContext);
              renderTask.promise.then(function () {
                console.log('Page rendered');
              });
            });
          })
        }else{
          var pagenumber = 1;
          pdf.getPage(pagenumber).then(function(page) {
            console.log('Page loaded');

            var scale = 1.5;
            var viewport = page.getViewport({scale: scale});

            // Prepare canvas using PDF page dimensions
            var canvas = document.getElementById('the-canvas1');

            var context = canvas.getContext('2d');
            canvas.height = viewport.height;
            canvas.width = viewport.width;

            // Render PDF page into canvas context
            var renderContext = {
              canvasContext: context,
              viewport: viewport
            };
            var renderTask = page.render(renderContext);
            renderTask.promise.then(function () {
              console.log('Page rendered');
            });
          });
        }



      }, function (reason) {
        // PDF loading error
        console.error(reason);
      });

    },

    fileUploading:function (FileURL){
      this.currentFileUrl = FileURL.currentFileURL
      this.showUploadedDocument = true
      this.fileUploadModal = false
      this.showLoadingModal = true

      console.log('files list-----')
      console.log(FileURL.files)
      var selectedFiles = []
      selectedFiles =  FileURL.files
      this.filesCount = selectedFiles.length

      if(selectedFiles.length > 1){
        for (let i = 0; i < selectedFiles.length; i++) {
          console.log('file array');
          console.log(selectedFiles[i])

          this.renderMultiplePDF(URL.createObjectURL(selectedFiles[i]));
        }
      }


    },

    renderMultiplePDF:function (url){
      var component = this
      // var  url = component.currentFileUrl

      pdfjsLib.GlobalWorkerOptions.workerSrc = pdfjsWorker
      var loadingTask = pdfjsLib.getDocument(url)

      loadingTask.promise.then(function(pdf) {
        console.log('PDF loaded');

        // Fetch the first page
        var totalpages = pdf.numPages;
        component.TotPage = totalpages
        console.log("Total pages : "+totalpages)

        for(var x = 1; x <= totalpages; x++){
          console.log("current page index : "+x)
          component.Pageindex.push({pageIndex:x})
        }

        if(totalpages > 1) {
          component.Pageindex.forEach((element)=>{
            pdf.getPage(element.pageIndex).then(function(page) {
              console.log('Page loaded');

              var scale = 1.5;
              var viewport = page.getViewport({scale: scale});

              // Prepare canvas using PDF page dimensions
              var canvas = document.getElementById('the-canvas'+element.pageIndex);

              var context = canvas.getContext('2d');
              canvas.height = viewport.height;
              canvas.width = viewport.width;

              // Render PDF page into canvas context
              var renderContext = {
                canvasContext: context,
                viewport: viewport
              };
              var renderTask = page.render(renderContext);
              renderTask.promise.then(function () {
                console.log('Page rendered');
              });
            });
          })
        }else{
          var pagenumber = 1;
          pdf.getPage(pagenumber).then(function(page) {
            console.log('Page loaded');

            var scale = 1.5;
            var viewport = page.getViewport({scale: scale});

            // Prepare canvas using PDF page dimensions
            var canvas = document.getElementById('the-canvas1');

            var context = canvas.getContext('2d');
            canvas.height = viewport.height;
            canvas.width = viewport.width;

            // Render PDF page into canvas context
            var renderContext = {
              canvasContext: context,
              viewport: viewport
            };
            var renderTask = page.render(renderContext);
            renderTask.promise.then(function () {
              console.log('Page rendered');
            });
          });
        }



      }, function (reason) {
        // PDF loading error
        console.error(reason);
      });

    },

    backtofirstScreen:function (){
      this.showAddInviteeModal = false

      this.inviteeFormData.fullName = ''
      this.inviteeFormData.contactNumber = ''
      this.inviteeFormData.nic=''
      this.inviteeFormData.position = ''
      this.inviteeFormData.email=''

      this.invalidEmail=''
      this.invalidFullName= ''
      this.invalidContactNumber= ''
      this.invalidNIC=''
      this.invalidPosition=''
      this.invalidStartNIC='',
      this.invalidPosition=''
      // this.showCheckInviteeNICModal = true

    },

    getTemplateList: function () {
      var comp = this

      try {
        axios.post(comp.$base_url + '/agent/getTemplateListforInternalStaffMembers', {
          user_id: comp.$root.user_id,
          auth_token:comp.$root.agentAuthToken
        })
            .then(function (response) {
              console.log("get template list---------------")
              console.log(response)

              if (response.data.success) {
                comp.templateList = response.data.data
              } else {
                comp.$buefy.toast.open({
                  message: "Failed to fetch data",
                  type: "is-danger",
                });
              }
            })
            .catch(function (error) {
              console.log(error)

              comp.$buefy.toast.open({
                message: "Failed to fetch data",
                type: "is-danger",
              });
            });

      } catch (e) {
        comp.$buefy.toast.open({
          message: e,
          type: "is-danger",
        });
        console.log("Exception occurred in Customer Template List getTemplateList() : " + e.message)
      }
    },

    mouseClickMove: function (event,elementID){
    var component = this

      if(component.isSaved == false){
        if(component.inviteeList.length == 0){ //check invitee list length equal to 0: then fire a validation msg
          component.$buefy.toast.open({
            message: 'Please Add Recipients',
            type: 'is-danger'
          })

        } else if(component.elementId == 0) { //check element id equal to 0: then fire a validation msg
          component.$buefy.toast.open({
            message: 'Please Select a Placeholder',
            type: 'is-danger'
          })
        }

        else{
          if(elementID <= 1){
            var target = document.getElementById(0);
            var xposition = (event.pageX - target.offsetLeft - target.offsetWidth/2);
            var yposition = (event.pageY- target.offsetTop - target.offsetHeight/2);
            target.style.transform = "translate("+ xposition + "px," + yposition + "px)";
            console.log('equal to 1---'+elementID)

          }else{
            console.log('more than 1---'+elementID--)
            var id = elementID--
            console.log('id----------'+id)
            target = document.getElementById(id);
            xposition = (event.pageX - target.offsetLeft - target.offsetWidth/2);
            yposition = (event.pageY- target.offsetTop - target.offsetHeight/2);
            target.style.transform = "translate("+ xposition + "px," + yposition + "px)";
          }


          console.log('x pos---'+xposition)
          console.log('y pos---'+yposition)
        }
      }


      // console.log('elem id'+elementID)
      // var x = event.pageX
      // var y = event.pageY
      //
      // console.log(event)
      // console.log('x----:'+x)
      // console.log('y----:'+y)
      //
      // var txt = document.getElementById(0)
      // txt.style.position = "absolute"
      // txt.style.lef = `${y}px`
      // txt.style.top = `${x}px`



    },


    removePlaceholders:function (id,type){
      var comp = this

      if(type == 'text-box'){
        comp.textBoxes.forEach((txtbox,index) =>{
          if(txtbox.id == id){
            comp.elementId --
            comp.textBoxes.splice(index, 1);
          }
        })
      }else if(type == 'signature'){
        comp.signatures.forEach((signature,index) =>{
          if(signature.id == id){
            comp.elementId --
            comp.signatures.splice(index, 1);
          }
        })
      }else if(type == 'date-picker'){
        comp.datepickers.forEach((datepick,index) =>{
          if(datepick,id == id){
            comp.elementId --
            comp.datepickers.splice(index, 1);
          }
        })
      }else if(type  == 'check-box'){
        comp.checkboxes.forEach((checkbox,index) =>{
          if(checkbox.id == id){
            comp.elementId --
            comp.checkboxes.splice(index, 1);
          }
        })
      }
      comp.showPlaceholderRemoveModal = false
    },

    openPlaceholderRemove:function (elementID,type){
      var comp = this
      comp.showPlaceholderRemoveModal = true
      comp.placeholderID = elementID
      comp.placeholderType = type
    },

    getAllCooridinatesBeforeSave:function (){
      var component = this

      try{


        //for text box-------------------------------------------------------------
        component.textBoxes.forEach((textbox)=>{

          //get element x & y coordinates
          var placeholder = document.getElementById(textbox.id)
          const style = window.getComputedStyle(placeholder)
          const matrix = style.transform || style.webkitTransform || style.mozTransform

          const matrixType = matrix.includes('3d') ? '3d' : '2d'
          const matrixValues = matrix.match(/matrix.*\((.+)\)/)[1].split(', ')
          if (matrixType === '2d') {
            const x = matrixValues[4]
            const y = matrixValues[5]

            //save coordinates values into the array
            component.coordinates.push(
                {
                  id:textbox.id,
                  Xcord:x,
                  Ycord:y,
                  invitee_id:textbox.inviteeid,
                  inviteeName:textbox.inviteeName,
                  type:textbox.type,
                  value:''
                })
          }

        })


        //for signatures-------------------------------------------------------------
        component.signatures.forEach((signature)=>{

          //get element x & y coordinates
          var placeholder = document.getElementById(signature.id)
          const style = window.getComputedStyle(placeholder)
          const matrix = style.transform || style.webkitTransform || style.mozTransform

          const matrixType = matrix.includes('3d') ? '3d' : '2d'
          const matrixValues = matrix.match(/matrix.*\((.+)\)/)[1].split(', ')
          if (matrixType === '2d') {
            const x = matrixValues[4]
            const y = matrixValues[5]

            //save coordinates values into the array
            component.coordinates.push(
                {
                  id:signature.id,
                  Xcord:x,
                  Ycord:y,
                  invitee_id:signature.inviteeid,
                  inviteeName:signature.inviteeName,
                  type:signature.type,
                  value:''
                })
          }

        })


        //for checkbox-------------------------------------------------------------
        component.checkboxes.forEach((checkbox)=>{

          //get element x & y coordinates
          var placeholder = document.getElementById(checkbox.id)
          const style = window.getComputedStyle(placeholder)
          const matrix = style.transform || style.webkitTransform || style.mozTransform

          const matrixType = matrix.includes('3d') ? '3d' : '2d'
          const matrixValues = matrix.match(/matrix.*\((.+)\)/)[1].split(', ')
          if (matrixType === '2d') {
            const x = matrixValues[4]
            const y = matrixValues[5]

            //save coordinates values into the array
            component.coordinates.push(
                {
                  id:checkbox.id,
                  Xcord:x,
                  Ycord:y,
                  invitee_id:checkbox.inviteeid,
                  inviteeName:checkbox.inviteeName,
                  type:checkbox.type,
                  value:''
                })
          }

        })

        //for datepicker-------------------------------------------------------------
        component.datepickers.forEach((datepciker)=>{

          //get element x & y coordinates
          var placeholder = document.getElementById(datepciker.id)
          const style = window.getComputedStyle(placeholder)
          const matrix = style.transform || style.webkitTransform || style.mozTransform

          const matrixType = matrix.includes('3d') ? '3d' : '2d'
          const matrixValues = matrix.match(/matrix.*\((.+)\)/)[1].split(', ')
          if (matrixType === '2d') {
            const x = matrixValues[4]
            const y = matrixValues[5]

            //save coordinates values into the array
            component.coordinates.push(
                {
                  id:datepciker.id,
                  Xcord:x,
                  Ycord:y,
                  invitee_id:datepciker.inviteeid,
                  inviteeName:datepciker.inviteeName,
                  type:datepciker.type,
                  value:''
                })
          }

        })

        component.isSaved =true
        return true
      }catch (error){

        console.log(error)
        return false
      }

    },


    //clear invitee data
    clearInviteeData:function (){

      this.inviteeFormData.fullName = ''
      this.inviteeFormData.contactNumber = ''
      this.inviteeFormData.nic=''
      this.inviteeFormData.position = null
      this.inviteeFormData.email=''

      this.invalidLanguage = ''
      this.invalidEmail=''
      this.invalidFullName= ''
      this.invalidContactNumber= ''
      this.invalidNIC=''
      this.invalidPosition=''
      this.invalidStartNIC=''

      this.showAddInviteeModal = false
      this.showExistInviteeModal = false
    },

    resetAssignInviteeModal:function (){
      this.selectedInvitee = null
    },


    // //show invitee add modal
    // showAddInviteeScreen:function (){
    //   var component =  this
    //
    //     component.showCheckInviteeNICModal = true
    //     component.showinviteesModal = false
    //
    //
    // },

    //check authentication
    validateToken:function (){
      var component = this
      axios.post(component.$base_url+'/agent/checkAuthentication', {
        auth_token:component.$root.agentAuthToken
      })
          .then(function (data) {
            var array =[]
            array = data.data
            component.formIsSubmitting = true

            console.log(array.data.message)
            if(array.success == true){
              component.username = array.data.name
              console.log(array.data.message)
            }else{
              component.$buefy.toast.open({
                message: array.data.message,
                type: 'is-danger'
              })
              component.$router.push({name:'agentSignin'})
            }

          })
          .catch(function (error) {
            var array =[]
            array = error.response
            //session expired
            console.log(array.data.success)
            if(array.data.success == false){
              component.$buefy.toast.open({
                message: 'Authentication failed',
                type: 'is-danger'
              })
              component.$router.push({name:'agentSignin'})
            }
          });

    },



    // //validate and check invitee nic exists
    // validateAndCheckNIC:function (){
    //   if(this.validateInviteeNIC()){
    //     this.inviteeFormData.nic = this.inviteeNIC
    //     this.checkInviteeNIC() // check nic exist
    //   }
    //   else{
    //     this.formIsInvalid = true
    //   }
    // },

    //validate invitee NIC only
    validateInviteeNIC:function (){
      var formIsValid = true

      var currentTime = new Date()
      var year = currentTime.getFullYear()
      var age

      if(this.inviteeNIC =='' || this.inviteeNIC.indexOf(' ') >= 0){
        this.invalidStartNIC = 'This field cannot left blank'
        formIsValid = false
      }
      else if(!this.regex.nic.test(this.inviteeNIC)){
        this.invalidStartNIC = 'Please enter valid NIC'
        formIsValid = false
      }else{

          if(this.inviteeNIC.length == 10){ //old nic
            console.log('old nic')
            var digits = this.inviteeNIC.substring(0,2)
            const BirthYear = Number("19"+digits);
            age  = year-BirthYear;
            if(age > 80){
              this.invalidStartNIC = 'Please enter valid NIC'
              formIsValid = false
            }
          }else if(this.inviteeNIC.length == 12){ //new nic
            var fourdigits = this.inviteeNIC.substring(0,4)
            age  = year-fourdigits;
            if(age > 80){
              this.invalidStartNIC = 'Please enter valid NIC'
              formIsValid = false
            }
          }
      }


      if(formIsValid){
        return true
      }
      else{
        return false
      }
    },

    //check invitee already exists or not
    checkInviteeNIC:function (){
      var component = this

      component.isSubmitting = true
      axios.post(component.$base_url+'/agent/checkInviteeExist',{
        nic:component.inviteeFormData.nic,
        auth_token:component.$root.agentAuthToken
      })
          .then(function (response){

            component.isSubmitting = false
            if(response.data.exists == true){
              var arr = []
              arr = response.data
              console.log(arr)
              component.inviteeExists = true
              component.clearInputNIC() //clear invitee nic first screen
              component.showCheckInviteeNICModal = false
              component.showAddInviteeModal = true

              //add existing invitee account details to input fields
              component.inviteeFormData.fullName = arr.data.inviteeData.invitee_name
              component.inviteeFormData.email = arr.data.inviteeData.invitee_email
              component.inviteeFormData.contactNumber = arr.data.inviteeData.invitee_contact_number
            }else{
              component.inviteeExists = false
              component.clearInputNIC() //clear invitee nic first screen
              component.showCheckInviteeNICModal = false
              component.showAddInviteeModal = true
            }

          }).catch(function (error) {
        console.log(error);
      });
    },

    clearInputNIC(){
      this.inviteeNIC = null
    },

    addInvitees:function (){

      if(this.validateInviteeForm()){
        this.addInviteesToList()
      }
      else{
        this.formIsInvalid = true
      }

    },


    validateInviteeForm:function (){
      var formIsValid = true

      // email
      if(this.inviteeFormData.email =='' || this.inviteeFormData.email.indexOf(' ') >= 0){
        this.invalidEmail = 'Email cannot be empty'
        formIsValid = false
      }
      else if(!this.regex.email.test(this.inviteeFormData.email)){
        this.invalidEmail = 'Please enter a valid email address'
        formIsValid = false
      }

      // full name
      if(this.inviteeFormData.fullName =='' ){
        this.invalidFullName = 'Name cannot be empty'
        formIsValid = false
      }
      else if(!this.regex.fullName.test(this.inviteeFormData.fullName)){
        this.invalidFullName = 'Name cannot contain numbers or special characters'
        formIsValid = false
      }

      //contact number
      if(this.inviteeFormData.contactNumber =='' || this.inviteeFormData.contactNumber.indexOf(' ') >= 0){
        this.invalidContactNumber = 'Contact number cannot be empty'
        formIsValid = false
      }
      else if(!this.regex.contactNumber.test(this.inviteeFormData.contactNumber)){
        this.invalidContactNumber = 'Please enter a valid contact number'
        formIsValid = false
      }


      //nic
      // if(this.inviteeFormData.nic =='' || this.inviteeFormData.nic.indexOf(' ') >= 0){
      //   this.invalidNIC = 'NIC cannot be empty'
      //   formIsValid = false
      // }
      // else if(!this.regex.nic.test(this.inviteeFormData.nic)){
      //   this.invalidNIC = 'Please enter valid NIC'
      //   formIsValid = false
      // }


      //position
      if(this.inviteeFormData.position ==null){
        this.invalidPosition = 'Position cannot be empty'
        formIsValid = false
      }

      //language
      if(this.inviteeFormData.language ==null){
        this.invalidLanguage = 'Language cannot be empty'
        formIsValid = false
      }

      if(formIsValid){
        return true
      }
      else{
        return false
      }
    },

    ValidateAndsendDocumentLink:function () {

      if (this.validateMessage()) {
        this.sendLinktoInvitees()
      } else {
        this.formIsInvalid = true
      }
    },

    //validate invitee message
    validateMessage:function (){
      var formIsValid = true

      if(this.showMessagetextBox == true){ //check add message check box is checked
        //message
        if(this.message =='' ){
          this.invalidMessage = 'Message cannot be empty'
          formIsValid = false
        }
        else if(!this.regex.message.test(this.message)){
          this.invalidMessage = 'Message cannot contain special characters or blanks'

          formIsValid = false
        }
      }else{
        formIsValid = true
      }


      if(formIsValid){
        return true
      }
      else{
        return false
      }
    },

    addInviteesToList:function (){
      var component = this

      component.findDuplicateInvitees(component.inviteeFormData.contactNumber,component.inviteeFormData.position)

    },


    findDuplicateInvitees : function(inviteeContact,sign_order){
    var component= this

      const uid = function(){
        return Date.now().toString(36) + Math.random().toString(36).substr(2);
      }

      //check client number available or not
      var cl_number = ''
      if(component.inviteeFormData.client_number){
        console.log('client number available------')
        cl_number = component.inviteeFormData.client_number
      }else{
        cl_number = uid()
      }

      var save_recipient = ''
      if(component.inviteeFormData.saveRecipient == ''){
        save_recipient = false
      }else if(component.inviteeFormData.saveRecipient == true){
        save_recipient = true
      }

      if(component.inviteeList.length <= 0){
        component.inviteeID++
        component.inviteeCount++
        component.inviteeList.push(
            {
              id:component.inviteeID,
              fullName:component.inviteeFormData.fullName,
              email:component.inviteeFormData.email,
              client_number:cl_number,
              contactNumber:component.inviteeFormData.contactNumber,
              sign_order:component.inviteeFormData.position,
              save_recipient:save_recipient,
              color:component.generateRandomBakcgroundColors()
            })

        component.positions.push(
            {
              name:'Position '+component.inviteeCount,
              value:component.inviteeCount,
            }
        )

        setTimeout(() => {
          component.setColorsToInviteeCard('inv'+component.inviteeID)
        }, 200)

        //show alert
        component.$buefy.toast.open({
          message: 'Successfully Added',
          type: 'is-success'
        })



        component.clearInputs()

        component.showAddInviteeModal =false
        component.showExistInviteeModal = false
        // component.showinviteesModal =true
      }else{

        var contact = component.inviteeList.findIndex(x => x.contactNumber == inviteeContact);
        var position = component.inviteeList.findIndex(y=> y.sign_order == sign_order);
        if(contact === -1){

          if(position === -1){
            component.inviteeID++
            component.inviteeCount++
            component.inviteeList.push(
                {
                  id:component.inviteeID,
                  fullName:component.inviteeFormData.fullName,
                  email:component.inviteeFormData.email,
                  client_number:cl_number,
                  contactNumber:component.inviteeFormData.contactNumber,
                  sign_order:component.inviteeFormData.position,
                  save_recipient:save_recipient,
                  color:component.generateRandomBakcgroundColors()
                })

            component.positions.push(
                {
                  name:'Position '+component.inviteeCount,
                  value:component.inviteeCount,
                }
            )


            setTimeout(() => {
              component.setColorsToInviteeCard('inv'+component.inviteeID)
            }, 200)


            component.clearInputs()
            //show alert
            component.$buefy.toast.open({
              message: 'Successfully Added',
              type: 'is-success'
            })
            component.showAddInviteeModal =false
            component.showExistInviteeModal = false
            // component.showinviteesModal =true

          }else{
            //show alert
            component.$buefy.toast.open({
              message: 'Cannot assign already assigned position to recipient',
              type: 'is-danger',
              duration: 5000,
            })
          }

        }else{
          //show alert
          component.$buefy.toast.open({
            message: 'This recipient already added into the document',
            type: 'is-danger'
          })
        }

      }
    },

    setColorsToInviteeCard:function (elementID){
      const background = document.getElementById(elementID);
      console.log(background);

      const setBackgroundColor = () => {
        background.style.backgroundColor= this.colorCode;
      };

      const setTextColor = () => {
        background.style.color = '#ffffff';
      };

      setBackgroundColor();
      setTextColor()
    },

    removeInvitee:function (id){
      var component = this

      //remove matching invitee id from textbox array
      for(var x = component.textBoxes.length-1; x>=0; x--){
        if(component.textBoxes[x]['inviteeid'] === id){
          component.textBoxes.splice(x,1)
        }
      }

    //remove matching invitee id from signatures array
      for(var i = component.signatures.length-1; i>=0; i--){
        if(component.signatures[i]['inviteeid'] === id){
          component.signatures.splice(i,1)
        }
      }

      //remove matching invitee id from date pickers array
      for(var y = component.datepickers.length-1; y>=0; y--){
        if(component.datepickers[y]['inviteeid'] === id){
          component.datepickers.splice(y,1)
        }
      }

      //remove matching invitee id from checkboxes
      for(var z = component.checkboxes.length-1; z>=0; z--){
        if(component.checkboxes[z]['inviteeid'] === id){
          component.checkboxes.splice(z,1)
        }
      }

      component.inviteeList.forEach((element,index)=>{
            if (element.id == id) {
              component.inviteeList.splice(index, 1);
              component.$buefy.toast.open({
                message: 'Recipient is removed',
                type: 'is-success'
              })

              if(component.positions.length > 1){
                var positionIndex = component.inviteeCount - 2
                component.positions.splice(positionIndex,1)
              }else{
                component.positions.splice(0,1)
              }

            }
      });


    },




    //render pdf
    renderPDF:function (){
      var component = this
      var  url = component.currentFileUrl

      pdfjsLib.GlobalWorkerOptions.workerSrc = pdfjsWorker
      var loadingTask = pdfjsLib.getDocument(url)

      loadingTask.promise.then(function(pdf) {
        console.log('PDF loaded');

        // Fetch the first page

        var totalpages = pdf.numPages;
        component.TotPage = totalpages
        console.log("Total pages : "+totalpages)

        for(var x = 1; x <= totalpages; x++){
          console.log("current page index : "+x)
          component.Pageindex.push({pageIndex:x})
        }

        if(totalpages > 1) {
          component.Pageindex.forEach((element)=>{
            pdf.getPage(element.pageIndex).then(function(page) {
              console.log('Page loaded');

              var scale = 1.5;
              var viewport = page.getViewport({scale: scale});

              // Prepare canvas using PDF page dimensions
              var canvas = document.getElementById('the-canvas'+element.pageIndex);

              var context = canvas.getContext('2d');
              canvas.height = viewport.height;
              canvas.width = viewport.width;

              // Render PDF page into canvas context
              var renderContext = {
                canvasContext: context,
                viewport: viewport
              };
              var renderTask = page.render(renderContext);
              renderTask.promise.then(function () {
                console.log('Page rendered');
              });
            });
          })
        }else{
          var pagenumber = 1;
          pdf.getPage(pagenumber).then(function(page) {
            console.log('Page loaded');

            var scale = 1.5;
            var viewport = page.getViewport({scale: scale});

            // Prepare canvas using PDF page dimensions
            var canvas = document.getElementById('the-canvas1');

            var context = canvas.getContext('2d');
            canvas.height = viewport.height;
            canvas.width = viewport.width;

            // Render PDF page into canvas context
            var renderContext = {
              canvasContext: context,
              viewport: viewport
            };
            var renderTask = page.render(renderContext);
            renderTask.promise.then(function () {
              console.log('Page rendered');
            });
          });
        }



      }, function (reason) {
        // PDF loading error
        console.error(reason);
      });


    },

    openInviteeAssingModal:function (elementType){
      var component = this
      if(component.inviteeList.length >0) {

        component.showInviteeAssignModal = true
        component.elementType = elementType
      }else{
        // console.log('please select position')
        component.$buefy.toast.open({
          message: 'Please add Recipient',
          type: 'is-danger'
        })
      }
    },

    //assing invitee to an element
    AddElementWithInviteeID:function (){
     var component = this

        if(component.selectedInvitee){
          component.addElements(component.elementType)
          component.selectedInvitee = null
        }else{
          component.$buefy.toast.open({
            message: 'Please select Recipient',
            type: 'is-danger'
          })
        }

    },

    //validate and add an elemnts into canvas
    addElements: function(elementType){
      var component = this
      var invitee_name =''

      //get location and ip
      component.getLocation()
      component.getAgentIp()

      component.inviteeList.forEach((element)=>{
        if(element.id == component.selectedInvitee){
          invitee_name = element.fullName
        }
      })

        if(elementType == 'text-box'){
          component.textBoxes.push(
              {
                id:component.elementId++,
                text:'value',
                type:'text-box',
                inviteeid:component.selectedInvitee,
                inviteeName:invitee_name,
                value:'',
              }
          )

        }else if(elementType == 'signature'){
          component.signatures.push(
              {
                id:component.elementId++,
                text:'',
                type:'signature',
                inviteeid:component.selectedInvitee,
                inviteeName:invitee_name,
                value:'',
              }
          )
        }else if(elementType == 'checkbox'){
          component.checkboxes.push(
              {
                id:component.elementId++,
                text:'',
                type:'checkbox',
                inviteeid:component.selectedInvitee,
                inviteeName:invitee_name,
                value:'',
              }
          )
        }else if(elementType == 'date-picker'){
          component.datepickers.push(
              {
                id:component.elementId++,
                text:'',
                type:'date-picker',
                inviteeid:component.selectedInvitee,
                inviteeName:invitee_name,
                value:'',
              }
          )
        }
      component.showInviteeAssignModal=false

      //assign invitee's colors to placeholder
      setTimeout(() => {
        component.assingColortoPlaceholders()
      }, 200)

    },

    validateDocumentName:function (){

      var formIsValid = true

      //document name
      if(this.documentName == ''){
        this.invalidDocumentName = 'Document Name cannot be empty'
        formIsValid = false
      }else if(!this.regex.fullName.test(this.documentName)){
        this.invalidDocumentName = 'Document Name cannot contain numbers or special characters'
        formIsValid = false
      }

      if(formIsValid){
        return true
      }else{
        return false
      }
    },


    savePDFwithCoordinates: async function (){
    var component = this

      if(component.validateDocumentName()){
        if(component.textBoxes.length > 0 || component.signatures.length >0 || component.datepickers.length >0 || component.checkboxes.length>0) {
          component.isSaveSubmitting = true //set loading true
          //save pdf into database
          event.preventDefault()

          let formData = new FormData();
          var attachmentfiles = component.attachments

          for (var index = 0; index < attachmentfiles.length; index++) {
            console.log('attachments files ---------------------------')
            console.log(attachmentfiles[index]['file'])
            formData.append("attachments[]", attachmentfiles[index]['file']);
          }

          formData.append('file',component.$root.file_url)
          formData.append('auth_token',component.$root.agentAuthToken)
          formData.append('signed_location',JSON.stringify(component.$root.agent_location_data))
          formData.append('signed_ip',component.$root.agent_ip_address)
          formData.append('document_name',component.documentName)

          axios.post(component.$base_url+'/agent/saveDocument',formData,{
            headers:{'content-type':'multipart/form-data'},

          })
              .then(function (response){
                var arr = [];
                arr = response.data
                if(arr.success == true){
                  var document_id = arr.data.document_id
                  component.SaveCoordinatesWithInvitee(document_id)
                }else{
                  component.$buefy.toast.open({
                    message: 'Failed to upload document',
                    type: 'is-danger'
                  })
                }

              })
              .catch(function (error) {
                console.log(error);
              });

        }else{
          component.$buefy.toast.open({
            message: 'Please make sure to add place holders into the document',
            type: 'is-danger',
            duration:3000
          })
        }

      }

    },

    SaveCoordinatesWithInvitee:function (documenID){
      var component = this
      var status =  component.getAllCooridinatesBeforeSave();
      if(status == true){
        const invitee_coordinates = component.coordinates;
        component.documentID = documenID

        let formData = new FormData()
        formData.append('auth_token',component.$root.agentAuthToken)
        formData.append('document_id',documenID)
        formData.append('invitees',JSON.stringify(component.inviteeList))
        formData.append('coordinates',JSON.stringify(invitee_coordinates))

        //check placholders if move or not
        axios.post(component.$base_url+'/agent/saveCoordinates', formData)
            .then(function (response){
              var arr = [];
              arr = response.data
              if(arr.success == true){
                component.isSaveSubmitting = false
                component.$buefy.toast.open({
                  message: 'Document successfully saved',
                  type: 'is-success'
                })
                component.isSaved = true
                component.enabledSaveButton = true
                component.documentInviteeIDArray = arr.data.documentInviteeIDArray


              }else{
                component.$buefy.toast.open({
                  message: 'Failed to save coordinates',
                  type: 'is-danger'
                })
              }

            })
            .catch(function (error) {
              console.log(error);
            });
      }else{
        component.$buefy.toast.open({
          message: 'Please make sure to drag the place holders from initial place',
          type: 'is-danger'
        })
        component.isSaveSubmitting = false
      }


    },

    getRecentDocs:function (){
     var component = this
      axios.post(component.$base_url+'/agent/getRecentDocs', {
        auth_token:component.$root.agentAuthToken,
      })
          .then(function (response){
            var arr = [];
            arr = response.data
            if(arr.success == true){
              console.log(arr)
              component.RecentDocs = arr.data.recentDoc
            }else{
              component.$buefy.toast.open({
                message: 'Failed to get recent documents',
                type: 'is-danger'
              })
            }

          })
          .catch(function (error) {
            console.log(error);
          });
    },

    checkDocumentsendPreviously:  async function (){ //check this document previously send to customer
      var comp = this

      try{
        let res = await axios({
          method: "post",
          url: comp.$base_url+'/agent/checkDocumentSentToPreviousClient',
          data: {
            auth_token:comp.$root.agentAuthToken,
            document_id:comp.documentID,
          },
        })

        if(res.data){
          // test for status you want, etc
          console.log('success file---------------')
          console.log(res.data)
        }
        // Don't forget to return something
        return res.data

      } catch(err){
        console.log(err)
      }
    },

    ResendModal() {
      var comp = this
      comp.$buefy.dialog.confirm({
        title: 'Resend Document',
        message: 'The document was sent previously to the customer. Do you want to resend the document?',
        confirmText: 'Resend',
        type: 'is-danger',
        hasIcon: true,
        onConfirm: () => comp.resendLink(),
        onCancel: ()=> comp.cancelResend()
      })
    },

    cancelResend:function (){
      var component = this
      component.isSubmitting = true
      var reviewOnly = ''
      if(component.reviewOnly){
        reviewOnly = 1
      }else{
        reviewOnly = 0
      }

      let formData = new FormData()
      formData.append('auth_token',component.$root.agentAuthToken)
      formData.append('invitees',JSON.stringify(component.inviteeList))
      formData.append('message',component.message)
      formData.append('location',component.$root.agent_location_data)
      formData.append('signed_ip',component.$root.agent_ip_address)
      formData.append('link',component.$customer_url)
      formData.append('document_id',component.documentID)
      formData.append('documentInviteeIDArray',JSON.stringify(component.documentInviteeIDArray))
      formData.append('reviewOnly',reviewOnly)

      axios.post(component.$base_url+'/agent/sendLinktoInvitees', formData)
          .then(function (response){
            var arr = [];
            arr = response.data
            if(arr.success == true){
              component.showSendDocModal = false
              component.showSendSuccessModal =true
              component.isSubmitting = false
            }else{
              component.isSubmitting = false
              component.$buefy.toast.open({
                message: 'Failed to send Document',
                type: 'is-danger'
              })
            }

          })
          .catch(function (error) {
            console.log(error);
          });
    },

    resendLink:function (){
      var component =  this

      let formData = new FormData()
      formData.append('auth_token',component.$root.agentAuthToken)
      formData.append('link',component.$customer_url)
      formData.append('document_id',component.documentID)

      axios.post(component.$base_url+'/agent/resendLink', formData)
          .then(function (response){
            var arr = [];
            arr = response.data
            if(arr.success == true){
              component.showSendDocModal = false
              component.showSendSuccessModal =true

            }else{
              component.isSubmitting = false
              component.$buefy.toast.open({
                message: 'Failed to send Document',
                type: 'is-danger'
              })
            }

          })
          .catch(function (error) {
            console.log(error);
          });
    },

    sendLinktoInvitees: function (){
      var component = this

      component.checkDocumentsendPreviously().then(res => {
        console.log(res)
        if(res.data.length > 0){
          component.ResendModal()

        } else{
          component.isSubmitting = true

          var reviewOnly = ''
          if(component.reviewOnly){
            reviewOnly = 1
          }else{
            reviewOnly = 0
          }

          let formData = new FormData()
          formData.append('auth_token',component.$root.agentAuthToken)
          formData.append('invitees',JSON.stringify(component.inviteeList))
          formData.append('message',component.message)
          formData.append('location',component.$root.agent_location_data)
          formData.append('signed_ip',component.$root.agent_ip_address)
          formData.append('link',component.$customer_url)
          formData.append('document_id',component.documentID)
          formData.append('documentInviteeIDArray',JSON.stringify(component.documentInviteeIDArray))
          formData.append('reviewOnly',reviewOnly)

          axios.post(component.$base_url+'/agent/sendLinktoInvitees', formData)
              .then(function (response){
                var arr = [];
                arr = response.data
                if(arr.success == true){
                  component.showSendDocModal = false
                  component.showSendSuccessModal =true
                  component.isSubmitting = false
                }else{
                  component.isSubmitting = false
                  component.$buefy.toast.open({
                    message: 'Failed to send Document',
                    type: 'is-danger'
                  })
                }

              })
              .catch(function (error) {
                console.log(error);
              });
        }
      })


    },

    getLocation:function (){
      var comp = this
      navigator.geolocation.getCurrentPosition(function(pos){

        comp.$root.agent_location_data = {
          lat: pos.coords.latitude,
          lng: pos.coords.longitude,
          accuracy: pos.coords.accuracy
        }

        console.log(pos.coords)
      })
    },

    generateRandomBakcgroundColors:function(){
        let color = "#";
        for (let i = 0; i < 3; i++)
          color += ("0" + Math.floor(Math.random() * Math.pow(16, 2) / 2).toString(16)).slice(-2);
        this.colorCode = color
        return color;

    },


    //get invitee's ip address
    getAgentIp:function (){
      fetch('https://api.ipify.org?format=json')
          .then(x => x.json())
          .then(({ ip }) => {
            this.$root.agent_ip_address = ip;
          });
    },

    resetWindow:function (){
      Object.assign(this.$data, this.initalState())
    },

    showInvtees:function (){
      this.showinviteesModal =true
    },

    showInviteesModal:function (){
      this.showAddInviteeModal=false
      this.showinviteesModal = true
    },

    openSendDocModal:function (){
      this.showSendDocModal = true
    },


    removeDoc:function (){
      this.showdocumentRemoveModal =false
      this.showUploadedDocument =false
      this.resetWindow()
    },

    resetInvalidStatus: function(key){

      this[key] = ''
      this.formIsInvalid = false


    },

    openFileUpload:function (){
      this.fileUploadModal = true
    },

    OpenAddInviteeModal:function (){
      this.showinviteesModal=false
      this.showAddInviteeModal=true
    },

    countDownTimer() {
      if(this.countDown > 0) {
        setTimeout(() => {
          this.countDown -= 1
          this.countDownTimer()
        }, 300)
      }else{
        this.showLoadingModal =false
        this.showSuccessModal =true
        this.showUploadedDocument = true
        this.renderPDF()
      }
    },



    clearInputs:function (){
      this.invalidFullName = ''
      this.invalidEmail=''
      this.invalidContactNumber=''
      this.invalidNIC=''
      this.invalidPosition=''
      this.invalidLanguage=''

      this.inviteeFormData.fullName=''
      this.inviteeFormData.contactNumber=''
      this.inviteeFormData.email=''
      this.inviteeFormData.nic=''
      this.inviteeFormData.position=null
    },


  }
}
</script>

<style scoped>
.modal-card-title{
  font-weight: bold;
  background-color: #0D5DA3;
  font-size: 28px;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  padding-bottom: 5px;
  margin-bottom: 15px;
}

.modal-card-body{
  border-radius: 0 0 5px 5px;
}


.item img{
  width: 60px;

}

.item{
  padding: 10px 10px 10px 30px;
  border-top-left-radius: 100%;
  border-bottom-left-radius: 100%;
}

.item:hover{
  background-color: #F2F4FF;
}

.box{
  box-shadow: 0px 9px 17px rgba(0, 0, 0, 0.1);
  height: 100%;
}

.card{
  background-color: #F2F4FF;
  height: 100vh;
}


ul{
  list-style-type:none;
  margin-top: 10px;
}



.docCard{
  margin-top: 10px;
  border-radius: 10px;
  background-color: white;
  padding: 10px;
  box-shadow: -4px 4px 4px rgba(13, 93, 163, 0.09);
}

.invitee-card{
  margin-top: 10px;
  border-radius: 10px;
  padding: 10px;
  box-shadow: -4px 4px 4px rgba(13, 93, 163, 0.09);

}
.invitee-card2{
  margin-top: 10px;
  border-radius: 10px;
  background-color: #FFD382;
  padding: 10px;
  box-shadow: -4px 4px 4px rgba(13, 93, 163, 0.09);
}

.invitee-card3{
  margin-top: 10px;
  border-radius: 10px;
  background-color: #93FF73;
  padding: 10px;
  box-shadow: -4px 4px 4px rgba(13, 93, 163, 0.09);
}


.upload-area{
  text-align: center;
  width: 70%;
  padding: 10px;
  border: 5px rgba(14, 98, 171, 0.5) dashed;
  border-radius: 20px;
  margin: auto;
  margin-top: 30px;
  position: relative;

}

.upload-area img{
  opacity: 50%;
}

#docButton{
  background-color: white;
  z-index: 1;
  margin:0;
  position: absolute;
  top: 50%;
  left: 50%;
  -ms-transform: translate(-50%,-50%);
  transform: translate(-50%,-50%);
}


.area{
  height: 100%;
  width: 100%;
  background-color: #F2F4FF;
  padding: 10px;
}

.buttons{
  margin-top: 80%;
  display: block;
}


.position1{
  margin-top: 10px;
  border-radius: 10px;
  padding: 10px;
  box-shadow: -4px 4px 4px rgba(13, 93, 163, 0.09);
  background-color: #76D9FF;
}

.position2{
  margin-top: 10px;
  border-radius: 10px;
  padding: 10px;
  box-shadow: -4px 4px 4px rgba(13, 93, 163, 0.09);
  background-color: #FFD382;
}

.position3{
  margin-top: 10px;
  border-radius: 10px;
  padding: 10px;
  box-shadow: -4px 4px 4px rgba(13, 93, 163, 0.09);
  background-color: #93FF73;
}

.img-doc{
  margin-top: 40px;
  width: 50%;
  height: 50%;
  text-align: center;
  margin: auto;
}


#drop-zone{
  width: 100%;

  /*margin-left: 80px;*/
}

.draggable {
  position: absolute;
  transition: all 0.3s ease-in-out;
}

.item img{
  width: 60px;

}

.item{
  padding: 10px 10px 10px 30px;
  border-top-left-radius: 100%;
  border-bottom-left-radius: 100%;
}

.item:hover{
  background-color: #F2F4FF;
}


.loading-modal{
  border-radius: 20px;
  background-color: white;
  height: 100%;
}

.slide-fade-enter-active {
  transition: all 0.3s ease-out;
}

.slide-fade-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter-from,
.slide-fade-leave-to {
  transform: translateX(20px);
  opacity: 0;
}

</style>

